import { o as ownerDocument } from './useSlotProps-263f7ba4.js';

function ownerWindow(node) {
  const doc = ownerDocument(node);
  return doc.defaultView || window;
}

export { ownerWindow as o };
//# sourceMappingURL=ownerWindow-b54d1bab.js.map
